import { useEffect, useState } from 'react';
import { useAppSelector } from '../../app/hooks';
import { selectFeatureFlagNotifyHitlBuild } from '../../redux/features/config/config.selector';
import { BUILD_NUMBER_CHECK_INTERVAL } from '../../utils/constants';
import logger from '../../utils/logger';

export function useBuildNumberCheck(interval = BUILD_NUMBER_CHECK_INTERVAL) {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const notifyHitlBuild = useAppSelector(selectFeatureFlagNotifyHitlBuild);

  useEffect(() => {
    // The build-number check is a deployment-only mechanism; skip it entirely
    // during local development (react-scripts sets NODE_ENV=development) so we
    // don't poll for a /buildNumber.json that isn't served locally.
    const isLocalDev = process.env.NODE_ENV === 'development';
    if (!notifyHitlBuild || isLocalDev) {
      return;
    }

    const checkBuildNumber = async () => {
      try {
        const res = await fetch('/buildNumber.json', { cache: 'no-store' });
        const { value } = await res.json();

        const currentBuildNumber = (window as any).__HITL_BUILD_NUMBER__;
        if (value !== currentBuildNumber) {
          setUpdateAvailable(true);
        }
      } catch (e: any) {
        logger.warn({
          message: 'Failed to check build number',
          error: e?.message,
        });
      }
    };

    const id = setInterval(checkBuildNumber, interval);
    return () => clearInterval(id);
  }, [interval, notifyHitlBuild]);

  const refreshApp = () => {
    window.location.reload();
  };

  const ignoreUpdate = () => {
    setUpdateAvailable(false);
  };

  return {
    updateAvailable,
    setUpdateAvailable,
    refreshApp,
    ignoreUpdate,
  };
}
